import type * as lazyIndex from './lazyIndex';
import { LazyImport, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "AuthRemediation"*/ './lazyIndex'),
    { name: 'AuthRemediation' }
);

// Delay loaded action as import since action does not allow to return non-void values
export const lazyRemediateAuth: LazyImport<typeof lazyIndex.remediateAuth, typeof lazyModule> =
    new LazyImport(lazyModule, m => m.remediateAuth);

export { isPromptForResourceTokenEnabled } from './isPromptForResourceTokenEnabled';
